import styled from 'styled-components'

import { useTranslation } from 'i18n-web/i18next'
import Text from 'components/Atoms/Text'

const Intro = styled(Text)`
  font-size: ${props => props.theme.font.size.desktop.regular};

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    font-size: ${props => props.theme.font.size.desktop.h4};
  }
`

const Title = styled(Text)`
  font-size: ${props => props.theme.font.size.mobile.h2};
  margin-bottom: 20px;
  margin-top: 10px;
  line-height: 120%;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    font-size: ${props => props.theme.font.size.mobile.h1};
  }

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.md}rem) {
    margin-bottom: 30px;
    font-size: ${props => props.theme.font.size.desktop.h2};
  }
`

const Description = styled(Text)`
  line-height: 180%;
  font-size: ${props => props.theme.font.size.desktop.regular};

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.md}rem) {
    line-height: 40px;
    font-size: ${props => props.theme.font.size.desktop.large};
  }
`

const Copy = ({ type }) => {
  const { t } = useTranslation()

  const renderCopy = () => {
    let copy

    switch (type) {
      case 'redeem':
        copy = (
          <>
            <Intro className="primary bold">
              {t('downloadApp.default.intro')}
            </Intro>
            <Title className="extraBold">{t('downloadApp.redeem.title')}</Title>
            <Description className="semiBold">
              {t('downloadApp.default.description')}
            </Description>
          </>
        )
        break
      case 'signup':
        copy = (
          <>
            <Intro className="primary bold">
              {t('downloadApp.default.intro')}
            </Intro>
            <Title className="extraBold">{t('downloadApp.signup.title')}</Title>
            <Description className="semiBold">
              {t('downloadApp.default.description')}
            </Description>
          </>
        )
        break
      case 'purchaseOnDemand':
        copy = (
          <>
            <Intro className="primary bold">
              {t('downloadApp.default.intro')}
            </Intro>
            <Title className="extraBold">
              {t('downloadApp.purchaseOnDemand.title')}
            </Title>
            <Description className="semiBold">
              {t('downloadApp.default.description')}
            </Description>
          </>
        )
        break
      case 'purchaseMonthly':
        copy = (
          <>
            <Intro className="primary bold">
              {t('downloadApp.default.intro')}
            </Intro>
            <Title className="extraBold">
              {t('downloadApp.purchaseMonthly.title')}
            </Title>
            <Description className="semiBold">
              {t('downloadApp.default.description')}
            </Description>
          </>
        )
        break
      case 'purchaseEvent':
        copy = (
          <>
            <Intro className="primary bold">
              {t('downloadApp.default.intro')}
            </Intro>
            <Title className="extraBold">
              {t('downloadApp.purchaseEvent.title')}
            </Title>
            <Description className="semiBold">
              {t('downloadApp.default.description')}
            </Description>
          </>
        )
        break
      case 'referral':
        copy = (
          <>
            <Intro className="primary bold">
              {t('downloadApp.default.intro')}
            </Intro>
            <Title className="extraBold">
              {t('downloadApp.referral.title')}
            </Title>
            <Description className="semiBold">
              {t('downloadApp.default.description')}
            </Description>
          </>
        )
        break
      case 'download':
        copy = (
          <>
            <Intro className="primary bold">
              {t('downloadApp.default.intro')}
            </Intro>
            <Title className="extraBold">
              {t('downloadApp.download.title')}
            </Title>
            <Description className="semiBold">
              {t('downloadApp.default.description')}
            </Description>
          </>
        )
        break
      default:
        copy = (
          <>
            <Intro className="primary bold">
              {t('downloadApp.default.intro')}
            </Intro>
            <Title className="extraBold">
              {t('downloadApp.default.title')}
            </Title>
            <Description className="semiBold">
              {t('downloadApp.default.description')}
            </Description>
          </>
        )
    }

    return copy
  }

  return renderCopy()
}

export default Copy
